import {parse, format, asYouType} from 'libphonenumber-js'

export function phoneField(field) {
    var value = field.value

    if (value) {
        const {country, phone} = parse(value, {country: {default: 'FR'}})
        if (country == 'FR') {
            value = format(phone, country, 'National')
        } else if (country) {
            value = format(phone, country, 'International')
        }
    }

    function onChange(event) {
        var nextValue = event.target.value

        if (nextValue) {
            const {country, phone} = parse(nextValue, {country: {default: 'FR'}})
            if (phone) {
                nextValue = format(phone, country, 'International_plaintext')
            } else {
                const formatter = new asYouType('FR')
                nextValue = formatter.input(nextValue)
            }
        }

        field.onChange(nextValue)
    }

    value = value || '' // fix uncontrolled input issue

    return {...field, value, onChange}
}

export function phonesField(field) {
    const arrayValue = field.value || []

    var value = arrayValue.map((value) => {
        if (value) {
            const {country, phone} = parse(value, {country: {default: 'FR'}})
            if (country == 'FR') return format(phone, country, 'National')
            if (country) return format(phone, country, 'International')
        }

        return value
    })

    function onChange(value) {
        var nextArrayValue = value.map((value) => {
            if (value) {
                const {country, phone} = parse(value, {country: {default: 'FR'}})
                if (phone) return format(phone, country, 'International_plaintext')
                
                const formatter = new asYouType('FR')
                return formatter.input(value)
            }
            return value
        })

        if (nextArrayValue.length == 1 && !nextArrayValue[0]) {
            // reset array
            nextArrayValue = []
        }

        field.onChange(nextArrayValue)
    }

    value = value.map((v) => v || '') // fix uncontrolled input issue

    return {...field, value, onChange}
}

export function phoneFormat(value) {
    if (value) {
        const {phone} = parse(value)
        return !!phone
    }
    return true
}

export default function(value) {

    function formatz() {
        if (value) {
            const {country, phone} = parse(value, {country: {default: 'FR'}})
            if (country == 'FR') return format(phone, country, 'National')
            if (country) return format(phone, country, 'International')
        }
        return value
    }

    function toNational() {
        const formatter = new asYouType('FR')
        formatter.input(value)
        return formatter.national_number
    }

    function toE164() {
        const {country, phone} = parse(value, {country: {default: 'FR'}})
        if (phone) return format(phone, country, 'International_plaintext')
        return null
    }

    return {format: formatz, toNational, toE164}
}


// WEBPACK FOOTER //
// ./lib/core/phonez.js